import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';
interface Props {
  amount: number;
}

const TempSignDocuments = ({ amount }: Props) => {
  const { i18n } = useLingui();
  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      title={i18n.t('Dokumenty gotowe do podpisu!')}
      thankYouMessage={
        <>
          {i18n.t('W celu otrzymania')}{' '}
          {amount.toLocaleString('PL', {
            style: 'currency',
            currency: 'PLN',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}{' '}
          {i18n.t('wymagamy podpisu umowy.')}
        </>
      }
    >
      <p className="body">
        {i18n.t('Skontaktujemy się z Tobą w celu finalizacji formalności.')}
      </p>
    </AfterDoc>
  );
};

export default TempSignDocuments;
